import { NestedFilterInput } from '@@types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchAllProducts } from '@entities/Product'

import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { ProductCarousel } from '@widgets/product-carousel'

import { IMAGE_SIZES, URL_PAGE_PRODUCT_FILTER } from '@shared/contants'

// Расширенный тип payload для ProductFilterBlock
interface ProductFilterPayload {
  filter?: NestedFilterInput;
  label?: string;
  i18n?: Array<{
    language_code: string;
    label: string;
  }>;
}

interface ProductFilterBlockProps extends Omit<BlockProps, 'payload'> {
  payload: ProductFilterPayload | null;
}

export default function ProductFilterBlock ({
  payload,
  shopId
}: ProductFilterBlockProps) {
  const { i18n } = useTranslation()
  
  const { products, loading, error } = useFetchAllProducts({
    filter: payload?.filter,
    sort: {
      fieldName: 'preview_id',
      direction: 1
    },
    shop_id:  shopId,
    style: IMAGE_SIZES.HERO
  }, !payload?.filter)

  // Получаем лейбл из переводов или дефолтный
  const label = payload?.i18n?.find((i) => 
    i.language_code === i18n.language
  )?.label ?? payload?.label

  const filterLink = useMemo(() => {
    if (!payload?.filter) return URL_PAGE_PRODUCT_FILTER
    const params = new URLSearchParams()
    params.set('filter', JSON.stringify(payload.filter))
    if (label) params.set('label', label)
    return `${URL_PAGE_PRODUCT_FILTER}?${params.toString()}`
  }, [ payload?.filter, label ])

  if (!products || products.length === 0) {
    return null
  }

  if (error) {
    console.error('Error fetching filtered products:', error)
    return null
  }

  return (
    <div className={styles.root__carousel}>
      <ProductCarousel
        title={label}
        products={products}
        loading={loading}
        link={filterLink}
      />
    </div>
  )
}